/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicGoal = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategicGoal model module.
   * @module model/StrategicGoal
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategicGoal</code>.
   * @alias module:model/StrategicGoal
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>StrategicGoal</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategicGoal} obj Optional instance to populate.
   * @return {module:model/StrategicGoal} The populated <code>StrategicGoal</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IdealState')) {
        obj['IdealState'] = ApiClient.convertToType(data['IdealState'], 'String');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('PerformancePerspectiveID')) {
        obj['PerformancePerspectiveID'] = ApiClient.convertToType(data['PerformancePerspectiveID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('CustomLabel')) {
        obj['CustomLabel'] = ApiClient.convertToType(data['CustomLabel'], 'String');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyVirtualTeamID')) {
        obj['CompanyVirtualTeamID'] = ApiClient.convertToType(data['CompanyVirtualTeamID'], 'Integer');
      }
      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('ExcludedFromBusinessReview')) {
        obj['ExcludedFromBusinessReview'] = ApiClient.convertToType(data['ExcludedFromBusinessReview'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} IdealState
   * @default ''
   */
  exports.prototype['IdealState'] = '';
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Integer} PerformancePerspectiveID
   */
  exports.prototype['PerformancePerspectiveID'] = undefined;
  /**
   * @member {Integer} StrategyDescriptionID
   */
  exports.prototype['StrategyDescriptionID'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {String} CustomLabel
   * @default ''
   */
  exports.prototype['CustomLabel'] = '';
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} CompanyVirtualTeamID
   */
  exports.prototype['CompanyVirtualTeamID'] = undefined;
  /**
   * @member {Integer} OwnerID
   */
  exports.prototype['OwnerID'] = undefined;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Boolean} ExcludedFromBusinessReview
   * @default false
   */
  exports.prototype['ExcludedFromBusinessReview'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


